module.exports = __webpack_public_path__ + "img/gongshi.f59b4e6b.png";